import { Column, Sorting } from "devextreme-react/data-grid";
import moment from 'moment';
import React, { useCallback, useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useRecoilState, useRecoilValue } from 'recoil';
import ActionsPanelComponent from 'shared/component/dxf-grid/actions-panel.component';
import DxfGrid from 'shared/component/dxf-grid/dxf-grid';
import OrderHeader from 'shared/component/orderHeader/orderHeader'
import { formatDate } from 'shared/helpers/utils';
import { balanceFilterAtom, useBalanceSource, usePreBalance } from './my-balance.service';

const MyBalance = () => {
  const [filter,setFilter] = useRecoilState(balanceFilterAtom)
  const balanceSource = useBalanceSource(filter)
  const{t}=useTranslation();


const handleSortDate = useCallback(sortBy => {
  let start = moment(sortBy.from).format()
  let end = moment(sortBy.to).format()
  setFilter({filter:{"StartDate":{"operator":"Equals","value":start},"EndDate":{"operator":"Equals","value":end}}})   
}, [setFilter]);

const {preBalance} = usePreBalance(filter?.filter?.StartDate?.value ?? '2020-10-11T00:00:00+02:00')



  return (
    <div className="myBooking shipping">
      <div className="container" >
        <OrderHeader title={t('my-balance.mainTitle')} handleSortDate={handleSortDate}/>
        <div className="dataTable">
          <DxfGrid dataSource={balanceSource} showPreBalance={true} preBalance={preBalance} colsSummery={['runningBalance','transactionEnglishName']}
>
            <Column allowSorting={false} dataField="transactionDate" caption={t('my-balance.recieve')}  cellRender={(c) => formatDate(c.value)} />
            <Column allowSorting={false} dataField="transactionEnglishName"  caption={t('my-balance.Transaction')}  />
            <Column allowSorting={false} dataField="ship" width='250' caption={t('my-balance.account')}/>
            <Column allowSorting={false} dataField="debit" caption={t('my-balance.debit')} />
            <Column allowSorting={false} dataField="credit" caption={t('my-balance.credit')} />
            <Column allowSorting={false} dataField="runningBalance" caption={t('my-balance.balance')}  calculateCellValue={(e)=> Math.round((e.runningBalance + Number.EPSILON) * 100) / 100} />
            <Column allowSorting={false} dataField="note" width='250' caption={t('my-balance.note')}/>
            <Column allowSorting={false}   cellRender={(cell) => <UserActions cell={cell}  />} />
          </DxfGrid>
        </div>
      </div>
    </div>
  );
}

export function UserActions({ cell, onDelete, onResend, onView }) {
  const row = cell.data;

  function getActions() {
    return [
      {
        label: "View Attachment",
        action: () => console.log(row),
      },
      { label: "Print", action: () => console.log(row) },
      { label: "Send By E-mail", action: () => console.log(row) },
    ];
  }

   return <ActionsPanelComponent actions={getActions()} />;
 // return <div></div>
}
export default MyBalance